import router from "../router";
import { useUserStore } from "../store/modules/user";
import { FEATURE, permission, permissionsByRole } from "../utils/constants/permission";
import { isRole, Roles } from "../utils/constants/user";

export const addRouteGuard = () => {
  const store = useUserStore();
  router.beforeResolve(async (to, from, next) => {
    try {
      if (store.authStatus == "error") {
        next();
        return;
      }
      if (store.authStatus == "" && store.getToken.length > 0) {
        await store.userRequest();
        next();
        return;
      } else if (store.authStatus == "") {
        store.userIdle();
        if (to.path == "/changePassword") {
          next();
        } else {
          next("/");
        }
        return;
      }
      if (isExpiredToken(store.getToken)) {
      }
      const role = store.getProfile.role;
      let featuresAllowed: string[] = [];
      if (store.tenantFeatures) {
        let allowed = store.tenantFeatures || "";
        featuresAllowed = allowed.split(",") as string[];
      }

      if (to.meta.rolesAllowed) {
        if (to.meta.rolesAllowed.length > 0) {
          if (!to.meta.rolesAllowed.includes(role)) {
            router.push({ name: "navigation.accessdenied", force: true });
          }
        }
      }
      if (to.meta.featureNames) {
        if (!to.meta.featureNames.some((item) => featuresAllowed.includes(item))) {
          router.push({
            name: "navigation.accessdenied",
            force: true,
          });
        }
      }

      next();
    } catch (e) {
      next("/");
    }
  });
};

export const isAuthorized = (permission: permission) => {
  const store = useUserStore();
  let role = "PUBLIC" as Roles;
  const foundRole = store.getProfile.role as Roles | string | undefined;
  if (foundRole != null) {
    if (isRole(foundRole)) {
      role = foundRole;
    }
  }

  const allowedPermissions = permissionsByRole[permission];
  if (allowedPermissions.includes(role)) {
    return true;
  }
  return false;
};

export const featureEnabled = (feature: FEATURE) => {
  const store = useUserStore();

  let role = "PUBLIC" as Roles;
  const enabledFeatures = (store.tenantFeatures.split(",") as string[]) || [];
  if (enabledFeatures != null) {
    if (enabledFeatures.includes(feature)) {
      return true;
    }
  }
  return false;
};

export const parseJWTToken = (token: string) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const isExpiredToken = (token: string) => {
  let isExpired = false;
  if (token.length > 0) {
    const decodedJwt = parseJWTToken(token);
    if (decodedJwt.exp * 1000 < Date.now()) {
      isExpired = false;
    }
    return isExpired;
  }
};
